export const Themes = ['arctic', 'halloween', 'bumblebee', 'autumn', 'twilight'];

export const DEFAULT_THEME = Themes[0];
